export default __webpack_public_path__ + "static/media/farmersMarket.13259cc9.png";